/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Script_SettingsInputs */

const en_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Script Settings`)
};

const fr_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres du script`)
};

const de_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skripteinstellungen`)
};

const it_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni script`)
};

const ru_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки скрипта`)
};

const es_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración del script`)
};

const zh_cn2_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`脚本设置`)
};

const ja_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スクリプト設定`)
};

const hi_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्क्रिप्ट सेटिंग्स`)
};

const pt_pt2_script_settings = /** @type {(inputs: Script_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de script`)
};

/**
* | output |
* | --- |
* | "Script Settings" |
*
* @param {Script_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const script_settings = /** @type {((inputs?: Script_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Script_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_script_settings(inputs)
	if (locale === "de") return de_script_settings(inputs)
	if (locale === "it") return it_script_settings(inputs)
	if (locale === "ru") return ru_script_settings(inputs)
	if (locale === "es") return es_script_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_script_settings(inputs)
	if (locale === "ja") return ja_script_settings(inputs)
	if (locale === "hi") return hi_script_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_script_settings(inputs)
	return en_script_settings(inputs)
});